import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import config from '../../config';
import { useGlobalContext } from '../../GlobalContext';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import { Update, GetById } from '../../service/GiftService';

export default function GiftEdit() {
  const {
    isLoading,
    setIsLoading,
    isAppError,
    setAppError,
    appErrorMessage,
    setAppErrorMessage,
    appErrorTitle,
    setAppErrorTitle,
    appErrorMode,
    setAppErrorMode,
    appUser
  } = useGlobalContext();

  const [name, setName] = useState('');
  const [image, setImage] = useState(null);

  //read id from useParams
  const { id } = useParams();

  const [status, setStatus] = useState('active');
  const [gift, setGift] = useState({});


  const handleFileChange = (event) => {
    const file = event.target.files[0];
    setImage(file);
    console.log(file);
  };

  const fetchGiftById = async () => {
    try {
      setIsLoading(true);
      var response = await GetById(id);
      if (response.status === 200) {
        setGift(response.gift);
        setName(response.gift.name);
        setImage(response.gift.image);
        setStatus(response.gift.status);
      }
    } catch (error) {
      setAppError(true);
      setAppErrorTitle("Error");
      setAppErrorMessage("Failed to load data");
      setAppErrorMode("error");
    } finally {
      setIsLoading(false);
    }
  };


  const saveGift = async (event) => {
    event.preventDefault();

    if (name.length < 3) {
      setAppError(true);
      setAppErrorTitle("Error");
      setAppErrorMessage("Name must be at least 3 characters");
      setAppErrorMode("error");
      return;
    }

    setIsLoading(true);

    try {
      const response = await Update(id, name, image, status);
      console.log(response);
      if (response.status === 200) {
        setAppError(true);
        setAppErrorTitle("Action Response");
        setAppErrorMessage(response.message || "Gift Successfully Updated");
        setAppErrorMode("success");
        window.location.href = "/gift/list";
      }
      else {
        setAppError(true);
        setAppErrorTitle("Error");
        setAppErrorMessage(response.message || "Failed to add gift. Please try again.");
        setAppErrorMode("error");
      }
    } catch (error) {
      setAppError(true);
      setAppErrorTitle("Error");
      setAppErrorMessage("Failed to add gift. Please try again.");
      setAppErrorMode("error");
    } finally {
      setIsLoading(false);
    }
  };

  React.useEffect(() => {
    if (id != null && id != undefined && id != "") {
      fetchGiftById();
    }
  }, []);


  return (
    <>
      <Helmet>
        <title>Gift Manage | {config.appName}</title>
      </Helmet>
      <div className='container'>
        <div className='page'>
          <div className='page-heading'>
            <h1>Edit Gift</h1>
            <span>
              <Link to="/"> Dashboard </Link> / <Link to="/gift/list"> Gift List </Link> / Gift Manage
            </span>
          </div>
          <div className='page-content'>
            <div className="portal">
              <div className='portal-body'>
                <div className='form'>
                  <form onSubmit={saveGift} encType='multipart/form-data'>
                    <div className='row'>
                      <div className='col-lg-6 col-md-6 col-sm-6 col-12'>
                        <div className="mb-3">
                          <label className="form-label">Name</label>
                          <input className='form-control' type='text' value={name} onChange={(e) => setName(e.target.value)} />
                        </div>
                      </div>
                      <div className='col-lg-5 col-md-6 col-sm-6 col-12'>
                        <div className="mb-3">
                          <label className="form-label">Image
                          </label>
                          <input className='form-control' type='file' onChange={handleFileChange} />                         
                        </div>
                      </div>
                      <div className='col-lg-1 col-md-6 col-sm-6 col-12'>
                        <div className="mb-3">                          
                          <img
                            src={`${config.imageBasePath}/gift/${gift.id}.${gift.image}`}
                            alt={gift.name} className='img-fluid image-xs'
                            style={{ width: '100px', marginTop: '10px', height: '55px' }} />
                        </div>
                      </div>
                      <div className='col-lg-3 col-md-3 col-sm-6 col-12'>
                        <div className="mb-3">
                          <label className="form-label">Status</label>
                          <br></br>
                          <input type='radio' name='status' value="active" onChange={(e) => setStatus(e.target.value)} checked={status === 'active'} /> Active &nbsp;&nbsp;
                          <input type='radio' name='status' value="inactive" onChange={(e) => setStatus(e.target.value)} checked={status === 'inactive'} /> Deactive
                        </div>
                      </div>
                      <div className='clearfix'></div>
                      <div className='col-12 text-end'>
                        <div className="mb-3">
                          <button type='reset' className='btn btn-danger btn-md'>
                            <i className="ri-reset-right-line"></i> Reset
                          </button>
                          &nbsp;&nbsp;
                          <button type='submit' className='btn btn-success btn-md'>
                            <i className="ri-check-fill"></i> Update Gift
                          </button>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
